import React, { useRef, useEffect, useState } from "react";
import { Button, makeStyles } from "@material-ui/core";

const LS_NAME = "audioMessageRate";

const useStyles = makeStyles((theme) => ({
  container: (props) => ({
    display: "flex",
    alignItems: "center",
    marginBottom: "7px",
    flexDirection: props.fromMe ? "row-reverse" : "row",
  }),
  rateButton: (props) => ({
    marginLeft: props.fromMe ? "0" : "5px",
    marginRight: props.fromMe ? "5px" : "0",
    color: theme.palette.type === "dark" ? "#fff" : "#000",
    border: `1px solid ${theme.palette.type === "dark" ? "#aaa" : "#999"}`,
    minWidth: "40px",
  }),
}));

export default function AudioMessage({ url, fromMe }) {
  const classes = useStyles({ fromMe });
  const audioRef = useRef(null);

  const [audioRate, setAudioRate] = useState(
    parseFloat(localStorage.getItem(LS_NAME) || "1")
  );
  const [showButtonRate, setShowButtonRate] = useState(false);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.playbackRate = audioRate;
    }
    localStorage.setItem(LS_NAME, audioRate.toString());
  }, [audioRate]);

  useEffect(() => {
    const handleStorageChange = () => {
      const newRate = parseFloat(localStorage.getItem(LS_NAME) || "1");
      setAudioRate(newRate);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.playbackRate = audioRate;
      audioRef.current.onplaying = () => setShowButtonRate(true);
      audioRef.current.onpause = () => setShowButtonRate(false);
      audioRef.current.onended = () => setShowButtonRate(false);
    }
  }, []);

  const toogleRate = () => {
    const newRate = { 0.5: 1, 1: 1.5, 1.5: 2, 2: 0.5 }[audioRate] || 1;
    setAudioRate(newRate);
    localStorage.setItem(LS_NAME, newRate.toString());
    window.dispatchEvent(new Event("storage"));
  };

  return (
    <div className={classes.container}>
      <audio ref={audioRef} controls>
        <source src={url} type="audio/ogg" />
      </audio>
      {showButtonRate && (
        <Button className={classes.rateButton} onClick={toogleRate}>
          {audioRate}x
        </Button>
      )}
    </div>
  );
}